
export const numOrNull = (v, asInt = false) => {
    const s = String(v ?? '').trim();
    if (!s) return null;
    const n = asInt ? parseInt(s, 10) : parseFloat(s);
    return Number.isNaN(n) ? null : n;
};

export const toISO = (yyyyMMddHHmm) => {
    const [d, t] = yyyyMMddHHmm.split(' ');
    const [Y, M, D] = d.split('/').map(Number);
    const [h, m] = t.split(':').map(Number);
    return new Date(Y, M - 1, D, h, m, 0, 0).toISOString();
};

export const normalizeArea = (v) => {
    const x = (v || '').trim();
    if (!x) return '';
    if (/^C\d{5}$/.test(x)) return x;
    if (/^\d{5}$/.test(x)) return `C${x}`;
    return x;
};
